module.exports = __webpack_public_path__ + "img/legal-assist.3d9e016c.png";